module.exports = __webpack_public_path__ + "assets/img/succ4.22fca677.png";